import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { CircularProgress, Grid, InputAdornment } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import { GroupedContainer } from '../GroupedContainer';

import { DialogContent, DialogContentText } from '@mui/material';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { SEND_NOTIF_COORD_ASISTENCIAL } from '../../../../data/graphQL/mutations/Contratos/SendNotificationCoordAsist';
import { UPDATE_EVOLUCION_ASISTENCIAL } from '../../../../data/graphQL/mutations/Contratos/UpdateEvolucionAsistencial';
import { GET_ADICIONALES_CONTRATO, adaptAdicionalesContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getAdicionalesContrato';
import { GET_ALIMENTACION_ENTERAL_CONTRATO, adaptAlimentacionEnteralContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getAlimentacionEnteralContrato';
import { GET_ALIMENTACION_PARENTERAL_CONTRATO, adaptAlimentacionParenteralContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getAlimentacionParenteralContrato';
import { GET_CONDICIONES_GENERALES_CONTRATO, adaptCondicionesGeneralesContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getCondicionesGeneralesContrato';
import { GET_DATOS_GENERALES_RI_ID } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getDatoGeneralRIId';
import { GET_EVOLUCION_ASISTENCIAL, adaptEvolucionAsistencial } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getEvolucionAsistencial';
import { GET_EXIST_CONEXIONES_EN_CONTRATO } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getExistConexionesEnContrato';
import { GET_NPID_CONTRATO, adaptNPIDContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getNPIDContrato';
import { GET_PLANES_SEARCH, adaptPlanesArray } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getPlanesSearch';
import { GET_PROFESIONALES_CONTRATO, adaptProfesionalesContrato } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getProfesionalesContrato';
import { VALIDATE_CONTRATO_PP_HAS_PLAN } from '../../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/validateContratoPPHasPlan';
import { CAN_REJECT_EVALUACION } from '../../../../data/graphQL/queries/Contratos/GestionInicio/canRejectEvaluacion';
import { GET_AUTORIZACION_CONTROL } from '../../../../data/graphQL/queries/Contratos/getAutorizacionControlInProgress';
import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { GET_CONTROL_RI_APROBADO_BY_EVALUACION } from '../../../../data/graphQL/queries/ResumenIngresoValidation/getControlRIAprobado';
import { normalizeFilterValue } from '../../../../helpers/tools';
import { invariantWithToast } from '../../../../hooks/invariantWithToast';
import { useDebounce } from '../../../../hooks/useDebounce';
import { DateDiff } from '../../../../utils/helpers';
import InformacionEquipo from '../../../RIValidation/components/InformacionEquipo';
import { hasMissingInstitucionAddressFields } from '../TabDireccionPaciente/TabDireccionPaciente';
import EvolucionAsistHistorial from './EvolucionAsistHistorial';
import { InsumosGridEvaluacion } from './InsumosGridEvaluacion';
import { SearchPlanes } from './SearchPlanes';
import { SolicitarCorreccionInput } from './SolicitarCorreccionInput';

import moment from 'moment';

const ESTADO_PRECIO_PENDIENTE = 1;

const planesColumns = [
  {
    field: 'id',
    headerName: '#',
    flex: 0.05
  },
  {
    field: 'codigoSap',
    headerName: 'Código',
    flex: 0.16
  },
  {
    field: 'programa',
    headerName: 'Programa',
    flex: 0.13
  },
  {
    field: 'nombre',
    headerName: 'Nombre',
    flex: 0.35
  },
  {
    field: 'complejidad',
    headerName: 'Complejidad',
    flex: 0.18
  },
  {
    field: 'cotizado',
    headerName: 'Cotizado',
    flex: 0.13
  }];


const ESTADO_MEDICO_APROBADO = 2;
const ESTADO_MEDICO_RECHAZADO = 1;
const PROGRAMAS_RP_OBLIGATORIO = ['SIP', 'SI', 'SSAP', 'SSAE'];

//#region Component
export const TabEvaluacionAsistencial = ({
  contratoEditable,
  fullFormData,
  programaRI,
  idPaciente,
  origen,
  idDelegacion,
  idEvaluacion,
  estadosEvolucionAsist,
  handleChangeFullFormData,
  tipoModulo,
  tipoModuloSelected,
  setDataSubmissionCallback,
  pageLoading,
  setPageLoading,
  cambioDireccion
}) => {

  const columns = useMemo(() => generateColumnsDefaultConfiguration(planesColumns), [planesColumns]);
  const [evaluacionAsistencial, setEvaluacionAsistencial] = useState({});
  const [indicaciones, setIndicaciones] = useState([]);
  const [coordinadorAprobo, setCoordinadorAprobo] = useState(false);
  const [existenConexiones, setExistenConexiones] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const [autControlInProgress, setAutControlInProgress] = useState(false);

  const ESTADO_COORDINACION_PENDIENTE = 1;
  const ESTADO_COORDINACION_APROBADO = 2;
  const ESTADO_COORDINACION_RECHAZADO = 3;
  const ESTADO_COORDINACION_CORRECCION = 4;



  const [getAutorizacionInProgress, { data: dataAutorizacionInProgress }] = useLazyQuery(GET_AUTORIZACION_CONTROL, {
    fetchPolicy: 'no-cache'
  });

  const [getExistConexionesEnContrato, { data: dataExistConexionesEnContrato }] = useLazyQuery(GET_EXIST_CONEXIONES_EN_CONTRATO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => { handleChangeFullFormData('evaluacionAsistencial', evaluacionAsistencial); }, [evaluacionAsistencial]);

  const [
    idDatosGenerales,
    datosRI,
    combosRI] =
    useGetRIData(idPaciente, programaRI, idEvaluacion);

  const [
    planesRows,
    planesTotalCount,
    filterStatus,
    setFilterStatus,
    planSelected] =
    useGetPlanes(evaluacionAsistencial?.idModulo, idDelegacion, idEvaluacion, fullFormData?.datosPrincipales?.franjaEtarea);

  const [getControlRI, { data: dataControlRI }] = useLazyQuery(GET_CONTROL_RI_APROBADO_BY_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataControlRI) return;
    setCoordinadorAprobo(dataControlRI?.controlRIAprobado);
  }, [dataControlRI]);

  useEffect(() => {
    if (!Boolean(datosRI)) return;
    const propsDatosRI = Object.entries(datosRI);
    propsDatosRI.forEach(([name, value]) => {
      handleChange(name, value);
    });
  }, [datosRI]);

  useEffect(() => {
    if (!!idPaciente) {
      getEvolucionAsistencial();
    }
    getControlRI({
      variables: {
        idEvaluacion
      }
    });
    getAutorizacionInProgress({ variables: { idEvaluacion } });
    getExistConexionesEnContrato({ variables: { idEvaluacion } });

  }, [idEvaluacion, idPaciente]);

  useEffect(() => {
    if (!dataAutorizacionInProgress) return;
    setAutControlInProgress(dataAutorizacionInProgress?.autorizacionControlInProgress);
  }, [dataAutorizacionInProgress]);

  useEffect(() => {
    if (!dataExistConexionesEnContrato) return;
    setExistenConexiones((prev) => prev || dataExistConexionesEnContrato?.existConexionByIdEvaluacion);
  }, [dataExistConexionesEnContrato]);

  const getEvolucionAsistencial = () => {
    if (!idEvaluacion) return;
    getEvolucionAsist({
      variables: {
        idEvaluacion,
        idPaciente
      }
    }).
      then((res) => {
        const evolucion = adaptEvolucionAsistencial(res?.data);
        setEvaluacionAsistencial((prevForm) => ({
          ...prevForm,
          ...evolucion
        }));
      }).catch();
  };

  const { data: contratoPPHasPlan } = useQuery(VALIDATE_CONTRATO_PP_HAS_PLAN, {
    variables: { idEvaluacion },
    fetchPolicy: 'no-cache',
    skip: !idEvaluacion || origen !== 'PP'
  });

  const [getEvolucionAsist, { loading }] = useLazyQuery(GET_EVOLUCION_ASISTENCIAL, {
    fetchPolicy: 'no-cache'
  });

  const [getCanUpdateIndicacion, { loading: verifyCanUpdateIndicacionLoading }] = useLazyQuery(CAN_REJECT_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    setPageLoading((prev) => prev || loading);
  }, [loading]);

  const [sendNotification, { data: dataNotificacion, loading: sendingNotif, error: errorNotificacion }] = useMutation(SEND_NOTIF_COORD_ASISTENCIAL, {
  });

  useEffect(() => {
    if (!dataNotificacion) return;
    if (dataNotificacion?.sendNotificationCoordinacionAsistencial) {
      toast.success('¡Notificación enviada!');
      getEvolucionAsistencial();
    } else

      toast.error('No existe programa de asistencia vinculado al contrato.');
  }, [dataNotificacion]);

  useEffect(() => {
    if (!errorNotificacion) return;
    toast.error('No se pudo enviar la notificación, intente más tarde.');
  }, [errorNotificacion]);

  const [updateEvolucionAsistencial] = useMutation(UPDATE_EVOLUCION_ASISTENCIAL);

  const handleChange = (name, value) => {
    setEvaluacionAsistencial((prevForm) => ({
      ...prevForm,
      [name]: value
    }));
  };

  const handleChangePlan = (value) => {
    const idModulo = value.row.id;
    if (!idModulo) return;

    const planSelected = planesRows.find((x) => x.id === idModulo);
    const { fechaDesde, fechaHasta } = fullFormData.condicionesContrato;
    const dias = DateDiff(new Date(moment(fechaDesde)), new Date(moment(fechaHasta)));

    if (planSelected?.cotizado === "SI" && dias > 91) {
      toast.error('Los contratos con planes de cuidados "cotizados" se deberán limitar a solo 92 días de largo.\n');
      return;
    }

    setPageLoading(true);

    updateEvolucionAsistencial({
      variables: {
        input: {
          idEvaluacion,
          idPlanCuidado: idModulo
        }
      }
    }
    )
      .then(() => {
        handleChange('idModulo', idModulo);
        toast.success('Plan de cuidado guardado correctamente.');
      })
      .catch((err) => {
        toast('Error al guardar evolución asistenical');
        console.log(err);
      }).finally(() => {
        setPageLoading(false);
      });

  }

  const handleChangeTipoNotificacion = async (name, value) => {
    if (value && origen === 'PR') {
      const response = await getCanUpdateIndicacion({
        variables: { idEvaluacion }
      });
      const { data } = response;
      if (!data) return toast.error('Error al verificar si se puede notificar.');
      if (data?.canRejectEvaluacion?.error) {
        toast.error('No se puede notificar ya que existen conexiones, para realizar esta acción se deberán quitar las conexiones.');
        return;
      }
    }

    handleChange(name, value);

  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const onConfirm = () => {
    sendNotification({
      variables: {
        idEvaluacion,
        tipoNotificacionAsistencial: tiposNotif.find((x) => x.id === evaluacionAsistencial.tipoNotificacion)?.id
      }
    });
    handleCloseModal();
  };

  const onClickSendNotification = () => {
    try {
      invariantWithToast(cambioDireccion, 'Debe validar nuevamente la geoposición en "Dirección Paciente".');
      invariantWithToast(!fullFormData.datosPrincipales.financiadorParticular && !fullFormData.datosPrincipales.idInstitucion,
        'Debe seleccionar una institución.'
      );
      invariantWithToast(
        hasMissingInstitucionAddressFields(fullFormData?.direccionPaciente) && origen !== 'PR' && (tipoModuloSelected.ri !== null || evaluacionAsistencial.tipoNotificacion === 'RESUMEN_INGRESO'),
        'Debe completar el lugar de evaluación (RI) del paciente.');
      invariantWithToast(!evaluacionAsistencial.tipoNotificacion,
        'Debe seleccionar un tipo de notificación.');
      invariantWithToast(!fullFormData?.direccionPaciente?.idLugarRI && evaluacionAsistencial.tipoNotificacion === 'RESUMEN_INGRESO',
        'Debe agregar el Lugar de Evaluacion del Paciente.');
      invariantWithToast(PROGRAMAS_RP_OBLIGATORIO.includes(programaRI) && !fullFormData.datosPrincipales?.derivacionPrescriptor,
        'Debe adjuntar RP.');

      if (origen === 'PR' && evaluacionAsistencial.estadoMedico === ESTADO_MEDICO_APROBADO) {
        handleOpenModal();
      } else {
        sendNotification({
          variables: {
            idEvaluacion,
            tipoNotificacionAsistencial: tiposNotif.find((x) => x.id === evaluacionAsistencial.tipoNotificacion)?.id
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getBuscadorPlanesDisabled = () => {
    return (
      !(!!evaluacionAsistencial.fechaNotifAsistencial && evaluacionAsistencial.estadoMedico === ESTADO_MEDICO_APROBADO) ||

      (evaluacionAsistencial.idEstadoConfirmarEquipo !== null &&
        evaluacionAsistencial.idEstadoConfirmarEquipo !== ESTADO_COORDINACION_APROBADO) ||

      !!evaluacionAsistencial.idModulo &&
      !!fullFormData?.gestionPresupuestos?.fechaEnvioPresupuesto &&
      !!fullFormData?.gestionPresupuestos?.idMedioEnvio &&
      !!fullFormData?.gestionPresupuestos?.idResultadoPresupuesto ||


      !!evaluacionAsistencial.idModulo &&
      !!fullFormData?.condicionesContrato?.observacion // si hay observación, se clickeó en "Pedir autorización"
      ||

      !!evaluacionAsistencial.idModulo && (
        fullFormData?.gestionPresupuestos?.fechaEnvioPresupuesto ||
        fullFormData?.gestionPresupuestos?.idResultadoPresupuesto === 1 ||
        fullFormData?.gestionPresupuestos?.idResultadoPresupuesto === 2)
    );


  };

  const validatedinputsRows = useMemo(() => {
    return structuredClone(inputGroups).filter((g) => !g.programType?.length || !!g.programType.length && g.programType.includes(programaRI)).
      map((group) => ({
        ...group,
        rows: group.rows.map((row) => ({
          ...row,
          inputs: row.inputs.map((input) => {
            if (!!input.comboName && !!combosRI) {
              input.options = combosRI[input.name];
            }
            switch (input.name) {
              case 'notificarCoordinacion':
                input.disabled = (origen !== 'PR' && fullFormData?.condicionesContrato?.estadoPrecio === ESTADO_PRECIO_PENDIENTE) ||
                  coordinadorAprobo ||
                  (origen == 'PR' && autControlInProgress) ||
                  evaluacionAsistencial.estadoMedico === ESTADO_MEDICO_RECHAZADO ||
                  !!evaluacionAsistencial.fechaNotifAsistencial ||
                  existenConexiones;
                break;
              case 'idComboRIValorModoInfusion':
              case 'idComboRIValorSelladoCateter':
                input.hidden = programaRI === 'NPID';
                if (input.hidden) handleChange(input.name);
                break;
              case 'idEstadoCoordinacion':
              case 'idEstadoConfirmarEquipo':
                input.options = estadosEvolucionAsist.
                  filter((x) => x.displayName === 'Aprobado' || x.displayName === 'Rechazado');
                break;
              case 'motivoRechazo':
                input.hidden = evaluacionAsistencial.estadoMedico !== 3;
                break;
              case 'tipoNotificacion': {
                const hasExisting =
                  !!evaluacionAsistencial.tipoNotificacion &&
                  !!evaluacionAsistencial.fechaNotifAsistencial;

                // 1) Si ya hay valor o estamos en loading, deshabilito y salgo.
                if (hasExisting || verifyCanUpdateIndicacionLoading) {
                  input.disabled = true;

                  if (hasExisting) {
                    const sel = tiposNotif.find((x) => x.id === evaluacionAsistencial.tipoNotificacion);
                    input.options = sel ? [sel] : [];
                    handleChange(input.name, evaluacionAsistencial.tipoNotificacion);
                  }

                  if (verifyCanUpdateIndicacionLoading) {
                    input.endAdornment =
                      <InputAdornment position="end">
                        <CircularProgress size={20} color="inherit" />
                      </InputAdornment>;

                  }

                  break;
                }

                // 2) Si no hay valor y no está en loading, sólo decido OPTIONS + DISABLED por origen:
                let options: typeof tiposNotif = [];
                let disabled = false;
                let defaultValue: string | undefined;

                if (origen === 'PP' || origen === 'US') {
                  if (tipoModuloSelected?.ri === true) {
                    disabled = true;
                    options = [tiposNotif.find((x) => x.id === 'RESUMEN_INGRESO')];
                    defaultValue = 'RESUMEN_INGRESO';
                  } else if (tipoModuloSelected?.ri === false) {
                    options = ['INGRESO_INDICACION', 'RESUMEN_INGRESO'].
                      map((id) => tiposNotif.find((x) => x.id === id));
                    defaultValue = 'INGRESO_INDICACION';
                  } else {// ri === null/undefined
                    disabled = true;
                    options = [tiposNotif.find((x) => x.id === 'INGRESO_INDICACION')];
                    defaultValue = 'INGRESO_INDICACION';
                  }

                } else if (origen === 'PR') {
                  options = [tiposNotif.find((x) => x.id === 'CAMBIO_INDICACION')];
                  defaultValue = 'CAMBIO_INDICACION';

                } else {
                  options = [tiposNotif.find((x) => x.id === 'INGRESO_INDICACION')];
                  defaultValue = 'INGRESO_INDICACION';
                }

                // 3) Aplico al input
                input.disabled = disabled;
                input.options = options;
                handleChange(input.name, defaultValue);

                break;
              }

              case 'idModulo':
                input.disabled = getBuscadorPlanesDisabled();
                break;
              case 'programa':
                input.options = tipoModulo;
                input.disabled = true;
                break;
              default:
                break;
            }
            if (!contratoEditable) {
              input.disabled = true;
            }
            return input;
          })
        }))
      }));
  }, [
    programaRI,
    combosRI,
    origen,
    coordinadorAprobo,
    estadosEvolucionAsist,
    fullFormData?.gestionPresupuestos?.fechaEnvioPresupuesto,
    fullFormData?.gestionPresupuestos?.idMedioEnvio,
    fullFormData?.gestionPresupuestos?.idResultadoPresupuesto,
    fullFormData?.direccionPaciente,
    contratoEditable,
    evaluacionAsistencial.fechaNotifAsistencial,
    evaluacionAsistencial.estadoMedico,
    verifyCanUpdateIndicacionLoading,
    autControlInProgress,
    tipoModuloSelected]
  );

  const onClickViewRI = async () => {
    const idRI = fullFormData?.evaluacionAsistencial?.idDatosGeneralesRI;
    if (!!idRI && !isNaN(idRI)) {
      navigate('/resumenIngreso/detalle',
        {
          state: {
            idDatosGeneralesRI: idRI,
            edit: false
          }
        });
    } else {
      toast.error("Resúmen de Ingreso no disponible.");
    }
  };

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
        <CircularProgress />
      </div>);

  }

  return (
    <div>
      <Grid
        container
        columnSpacing={3}
        rowSpacing={3}
        columns={100}>

        <EvolucionAsistHistorial idEvaluacion={idEvaluacion} />
        {validatedinputsRows.map((group, rowIndex) => {
          return <GroupedContainer key={rowIndex} ungrouped={!group.name} sectionTitle={group.name}>
            {group.rows.map((row) =>
              row.inputs.
                filter((i) => !i.hidden).
                map((input, index) => {
                  return (
                    <Fragment key={`row-${rowIndex}-input-${input.name}-input-index-${index}`}>
                      {input.name !== 'idComboRIValorFasePaciente' &&
                        input.name !== 'tipoNotificacion' &&
                        input.name !== 'indicacion' &&
                        input.name !== 'idModulo' &&
                        input.name !== 'notificarCoordinacion' &&
                        input.name !== 'verRI' &&
                        input.name !== 'solicitarModificar' &&
                        input.name !== 'confirmarEquipo' ?

                        <RenderInputsRowByType
                          input={input}
                          value={evaluacionAsistencial[input.name]}
                          handleChange={handleChange}
                          key={`row-${rowIndex}-input-${input.name}-input-index-${index}`} /> :

                        <Grid size={{ xs: 100, sm: 50, md: input.col }}>
                          {input.name === 'idComboRIValorFasePaciente' &&
                            <div className='chip-fase'>
                              <span>Fase:
                                <strong> {combosRI?.idComboRIValorFasePaciente?.find((x) => x.id === evaluacionAsistencial.idComboRIValorFasePaciente)?.displayName || '-'}
                                </strong>
                              </span>
                            </div>
                          }
                          {input.name === 'tipoNotificacion' &&
                            <RenderInputByTypeMobile
                              input={input}
                              value={evaluacionAsistencial[input.name]}
                              handleChange={handleChangeTipoNotificacion}
                              key={`row-${rowIndex}-input-${input.name}-input-index-${index}`} />

                          }
                          {input.name === 'indicacion' &&
                            <InsumosGridEvaluacion
                              idDatosGeneralesRI={evaluacionAsistencial.idDatosGeneralesRI}
                              idTipoModulo={fullFormData?.datosPrincipales?.idTipoModulo}
                              indicaciones={indicaciones}
                              setIndicaciones={setIndicaciones}
                              idEvaluacion={idEvaluacion} />

                          }
                          {input.name === 'idModulo' &&
                            <SearchPlanes
                              rows={planesRows}
                              columns={columns}
                              value={!!planSelected.codigoSap ? `${planSelected?.codigoSap} - ${planSelected?.nombre}` : ''}
                              totalCount={planesTotalCount}
                              filterStatus={filterStatus}
                              setFilterStatus={setFilterStatus}
                              handleRowClick={handleChangePlan}
                              disabled={input.disabled} />

                          }
                          {input.name === 'notificarCoordinacion' &&
                            <CustomButton
                              onClick={onClickSendNotification}
                              isLoading={sendingNotif}
                              disabled={input.disabled}
                              fullWidth
                              className='button-notificar-coordinacion'>

                              {input.displayName}
                            </CustomButton>
                          }
                          {input.name === 'verRI' &&
                            <CustomButton
                              onClick={onClickViewRI}
                              disabled={
                                !(fullFormData.evaluacionAsistencial.idDatosGeneralesRI > 0 && (
                                  fullFormData.evaluacionAsistencial.idEstadoCoordinacion === ESTADO_COORDINACION_APROBADO ||
                                  fullFormData.evaluacionAsistencial.idEstadoCoordinacion === ESTADO_COORDINACION_RECHAZADO))

                              }
                              fullWidth
                              className='button-notificar-coordinacion'
                              variant='outlined'>

                              {input.displayName}
                            </CustomButton>
                          }
                          {input.name === 'solicitarModificar' &&
                            <SolicitarCorreccionInput
                              disabled={input.disabled ||
                                !evaluacionAsistencial.fechaNotifAsistencial ||
                                origen == 'PP' && contratoPPHasPlan?.validateContratoPPHasPlan ||
                                !!fullFormData.evaluacionAsistencial.idModulo ||
                                fullFormData.evaluacionAsistencial.idEstadoConfirmarEquipo !== ESTADO_COORDINACION_APROBADO ||
                                fullFormData.evaluacionAsistencial.idEstadoCoordinacion !== ESTADO_COORDINACION_APROBADO
                              }
                              idEvaluacion={idEvaluacion}
                              column={input.col}
                              onCompletedSolicitarCorreccion={getEvolucionAsistencial} />

                          }
                          {input.name === 'confirmarEquipo' &&
                            <InformacionEquipo
                              idEvaluacion={idEvaluacion}
                              isFromEvolucionAsistencial />

                          }
                        </Grid>
                      }
                    </Fragment>);

                })
            )}
          </GroupedContainer>;
        })}
      </Grid>

      <CustomDialog
        open={openModal}
        onClose={handleCloseModal}
        title='Advertencia!'
        onCancel={handleCloseModal}
        onAccept={onConfirm}
        acceptText='Confirmar'
        fullWidth={true}>

        <DialogContent>
          <DialogContentText>Si confirma, el contrato cambiará a estado "Pendiente", el paciente no continuará en servicio hasta
            que el área de coordinación realice el cambio de indicación.</DialogContentText>
        </DialogContent>
      </CustomDialog>
    </div>);

};
//#endregion

//#region customHook
const useGetRIData = (idPaciente, programaRI, idEvaluacion) => {

  const [idDatosGenerales, setIdDatosGenerales] = useState(null);
  const [combosRI, setCombosRI] = useState([]);

  //AE
  const [dataAE, setDataAE] = useState();
  //AP / NPID / SIP
  const [dataAP, setDataAP] = useState();
  const [dataNPID, setDataNPID] = useState();

  const [dataCondGrales, setDataCondGrales] = useState();

  const [dataEquipos, setDataEquipos] = useState();
  const [dataAdicionales, setDataAdicionales] = useState();

  const { data: dataQueryCombos } = useQuery(getStringQueryCombosRI(inputCombos), {
    fetchPolicy: 'no-cache'
  });

  const [getIdDatosGenerales] = useLazyQuery(GET_DATOS_GENERALES_RI_ID, {
    fetchPolicy: 'no-cache'
  });
  const [getAEData] = useLazyQuery(GET_ALIMENTACION_ENTERAL_CONTRATO, {
    fetchPolicy: 'no-cache'
  });
  const [getAPData] = useLazyQuery(GET_ALIMENTACION_PARENTERAL_CONTRATO, {
    fetchPolicy: 'no-cache'
  });
  const [getNPIDData] = useLazyQuery(GET_NPID_CONTRATO, {
    fetchPolicy: 'no-cache'
  });
  const [getCondGralData] = useLazyQuery(GET_CONDICIONES_GENERALES_CONTRATO, {
    fetchPolicy: 'no-cache'
  });
  const [getProfesionales] = useLazyQuery(GET_PROFESIONALES_CONTRATO, {
    fetchPolicy: 'no-cache'
  });
  const [getAdicionales] = useLazyQuery(GET_ADICIONALES_CONTRATO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataQueryCombos) return;
    setCombosRI(adaptCombosRIArray(dataQueryCombos));
  }, [dataQueryCombos]);

  useEffect(() => {
    if (!idEvaluacion) return;
    getIdDatosGenerales({ variables: { idEvaluacion } })
      .then(({ data }) => {
        setIdDatosGenerales(data?.datosGeneralesRIByEvaluacionId);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getIdDatosGenerales:", error);
      });
  }, [idEvaluacion]);

  useEffect(() => {
    if (!idDatosGenerales) return;
    getCondGralData({ variables: { idDatosGenerales } }).
      then((res) => {
        const cgContrato = adaptCondicionesGeneralesContrato(res?.data);
        setDataCondGrales(cgContrato);
      });
  }, [idDatosGenerales]);

  useEffect(() => {
    if (!idDatosGenerales || programaRI !== 'AE') return;
    getAEData({ variables: { idDatosGenerales } }).
      then((res) => {
        const aeContrato = adaptAlimentacionEnteralContrato(res?.data);
        setDataAE(aeContrato);
      });
  }, [idDatosGenerales, programaRI]);

  useEffect(() => {
    if (!idEvaluacion || programaRI !== 'AP' && programaRI !== 'SIP') return;
    getAPData({ variables: { idEvaluacion } }).
      then((res) => {
        const apContrato = adaptAlimentacionParenteralContrato(res?.data);
        setDataAP(apContrato);
      });
  }, [idEvaluacion, idDatosGenerales, programaRI]);

  useEffect(() => {
    if (!idDatosGenerales || programaRI !== 'NPID') return;
    getNPIDData({ variables: { idDatosGenerales } }).
      then((res) => {
        const npidContrato = adaptNPIDContrato(res?.data);
        setDataNPID(npidContrato);
      });
  }, [idDatosGenerales, programaRI]);

  useEffect(() => {
    if (!idEvaluacion || programaRI !== 'CP' && programaRI !== 'CD') return;
    getProfesionales({ variables: { idEvaluacion } }).
      then((res) => {
        const { profesionalRI } = adaptProfesionalesContrato(res?.data);
        setDataEquipos({ ...profesionalRI });
      });
    getAdicionales({ variables: { idEvaluacion } }).
      then((res) => {
        setDataAdicionales(adaptAdicionalesContrato(res?.data));
      });
  }, [idEvaluacion, idDatosGenerales, programaRI]);

  const datosRI = useMemo(() => ({
    ...dataAE,
    ...dataAP,
    ...dataNPID,
    ...dataCondGrales,
    ...dataEquipos,
    ...dataAdicionales
  }), [dataAE, dataAP, dataNPID, dataCondGrales, dataEquipos, dataAdicionales]);

  return [
    idDatosGenerales,
    datosRI,
    combosRI];

};

const useGetPlanes = (idModuloSelected, idDelegacion, idEvaluacion, franjaEtaria) => {
  const [planes, setPlanes] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');

  const filterValue = useDebounce(filterStatus.toLowerCase(), 500);

  const [planSelected, setPlanSelected] = useState({});

  const filteredPlanes = useMemo(() => {
    const inputBuscar = normalizeFilterValue(filterValue);
    if (inputBuscar?.length) {
      return planes?.filter((planOriginal) => {
        const nombre = planOriginal.nombre.toString().toUpperCase();
        const codigoSap = planOriginal.codigoSap.toUpperCase();
        return (
          nombre.includes(inputBuscar) ||
          codigoSap.includes(inputBuscar));

      }) || [];

    } else {
      return planes;
    }
  }, [planes, filterValue]);

  useEffect(() => {
    if (!idModuloSelected) return setPlanSelected({});
    if (planSelected.id === idModuloSelected) return;
    const plan = planes?.find((x) => x.id === idModuloSelected);

    if (!!plan)
      return setPlanSelected(plan);
  }, [idModuloSelected, franjaEtaria]);

  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getPlanes, { data: dataPlanes, loading: planesLoading }] = useLazyQuery(GET_PLANES_SEARCH, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPlanes) return;
    setPlanes(adaptPlanesArray(dataPlanes.planesSearch.valorEsperado));
  }, [dataPlanes]);

  useEffect(() => {
    if (!planesLoading) {
      getPlanes({
        variables: {
          filter: {
            idDelegacion: idDelegacion,
            idEvaluacion: idEvaluacion,
            idFranjaEtaria: franjaEtaria == 'Adulto' ? 2 : 1
          }
        }
      });
    }
  }, [idDelegacion, franjaEtaria]);

  return [
    filteredPlanes,
    filteredPlanes?.length || 0,
    filterStatus,
    setFilterStatus,
    planSelected];

};

//#endregion

//#region constants

const tiposNotif = [
  { id: 'RESUMEN_INGRESO', displayName: 'Resumen de ingreso' },
  { id: 'INGRESO_INDICACION', displayName: 'Ingreso de indicación' },
  { id: 'CAMBIO_INDICACION', displayName: 'Cambio de indicación' }];


const inputCombos = [
  { name: 'idComboRIValorFasePaciente', comboName: 'Fase del paciente Inicio' },
  { name: 'idComboRIValorTipoAcceso', comboName: 'Tipo de Acceso' },
  { name: 'idComboRIValorModoInfusion', comboName: 'Modo de infusión AP' },
  { name: 'idComboRIValorSelladoCateter', comboName: 'Sellado de catéter AP' }];


const inputGroups = [
  {
    ungrouped: true,
    rows: [
      {
        inputs: [
          {
            displayName: 'Notificar coordinación asistencial',
            name: 'notificarCoordinacion',
            type: 'button',
            onClick: null,
            col: 28
          },
          {
            displayName: 'Tipo de notificación',
            name: 'tipoNotificacion',
            type: 'select',
            options: [...tiposNotif],
            required: true,
            col: 22
          },
          {
            displayName: 'Fecha de notificación',
            name: 'fechaNotifAsistencial',
            type: 'datetime',
            disabled: true,
            col: 20
          },
          {
            displayName: 'Estado validación',
            name: 'idEstadoCoordinacion',
            type: 'button_options',
            fitContent: true,
            options: [],
            disabled: true,
            col: 22
          }]

      },
      {
        inputs: [
          {
            displayName: 'Profesional Creador',
            name: 'profesional',
            type: 'string',
            disabled: true,
            col: 28
          },
          {
            displayName: 'Fecha Cierre R.I.',
            name: 'fechaCierreRIMedico',
            type: 'datetime',
            disabled: true,
            col: 20
          },
          {
            displayName: 'Profesional Validador',
            name: 'usuarioCoordinador',
            type: 'string',
            disabled: true,
            col: 30
          }]

      },
      {
        inputs: [
          {
            displayName: 'Motivo de bloqueo / rechazo',
            name: 'motivoRechazo',
            type: 'string',
            disabled: true,
            col: 80
          },
          {
            displayName: 'Fecha aprobación R.I.',
            name: 'fechaEstadoMedico',
            type: 'datetime',
            disabled: true,
            col: 20
          }]

      },
      {
        inputs: [
          {
            displayName: 'Observación extra',
            name: 'observacionMedica',
            type: 'long_string',
            disabled: true,
            col: 100
          }]

      }]

  },
  {
    name: 'Confirmación de Equipo',
    rows: [
      {
        inputs: [
          {
            name: 'confirmarEquipo',
            type: 'custom',
            col: 75
          },
          {
            displayName: 'Estado',
            name: 'idEstadoConfirmarEquipo',
            type: 'button_options',
            fitContent: true,
            options: [],
            disabled: true,
            col: 18
          }]

      }]

  },
  {
    name: 'Datos importantes del RI',
    rows: [
      {
        inputs: [
          {
            displayName: 'Programa',
            name: 'programa',
            type: 'select',
            required: true,
            col: 23
          },
          {
            displayName: 'Fase',
            name: 'idComboRIValorFasePaciente',
            type: 'string',
            required: true,
            col: 7
          },
          {
            displayName: 'Paciente puede hacer telemedicina',
            name: 'dispositivoParaVideoConf',
            type: 'custom_switch',
            textLight: true,
            disabled: true,
            col: 20
          },
          {
            displayName: 'Ver RI',
            name: 'verRI',
            type: 'button',
            variant: 'outlined',
            col: 10
          },
          {
            displayName: 'Solicitar Modificar',
            name: 'solicitarModificar',
            type: 'button',
            variant: 'outlined',
            col: 40
          }]

      }]

  },
  {
    name: 'Indicación Médica',
    rows: [
      {
        inputs: [
          {
            displayName: '',
            name: 'indicacion',
            type: 'grid',
            required: true,
            col: 100
          }]

      }]

  },
  {
    name: 'AE',
    programType: ['AE'],
    rows: [
      {
        inputs: [
          {
            displayName: 'Tipo de Acceso',
            name: 'idComboRIValorTipoAcceso',
            comboName: 'Tipo de Acceso',
            type: 'select',
            disabled: true,
            col: 33
          },
          {
            displayName: 'Cambio de sonda domiciliaria',
            name: 'cambioSNGdomicilio',
            type: 'custom_switch',
            disabled: true,
            textLight: true,
            col: 33
          },
          {
            type: 'item',
            col: 42
          }]

      }]

  },
  {
    name: 'AP / NPID / SIP',
    programType: ['AP', 'NPID', 'SIP'],
    rows: [
      {
        inputs: [
          {
            displayName: 'BAP Magistral Volumen',
            name: 'volumenMagistral',
            type: 'string',
            disabled: true,
            col: 33
          },
          {
            displayName: 'Modo Infusión',
            name: 'idComboRIValorModoInfusion',
            comboName: 'Modo de infusión AP',
            type: 'select',
            disabled: true,
            col: 33
          },
          {
            displayName: 'Sellado de catéter',
            name: 'idComboRIValorSelladoCateter',
            comboName: 'Sellado de catéter AP',
            type: 'select',
            disabled: true,
            col: 33
          }]

      },
      {
        inputs: [
          {
            displayName: 'Esquema BAP',
            name: 'diaConexionRIMagistral',
            type: 'checkbox',
            options: [
              { value: 1, label: 'L' },
              { value: 2, label: 'M' },
              { value: 3, label: 'X' },
              { value: 4, label: 'J' },
              { value: 5, label: 'V' },
              { value: 6, label: 'S' },
              { value: 7, label: 'D' }],

            required: true,
            disabled: true,
            col: 100
          },
          {
            displayName: 'Esquema BAP Estándar',
            name: 'diaConexionRIEstandar',
            type: 'checkbox',
            options: [
              { value: 1, label: 'L' },
              { value: 2, label: 'M' },
              { value: 3, label: 'X' },
              { value: 4, label: 'J' },
              { value: 5, label: 'V' },
              { value: 6, label: 'S' },
              { value: 7, label: 'D' }],

            required: true,
            disabled: true,
            col: 100
          }]

      }]

  },
  {
    name: 'Equipo de Profesionales',
    programType: ['CP', 'CD'],
    rows: [
      {
        inputs: [
          {
            displayName: 'Equipo de seguimiento',
            name: 'profesionalRI',
            type: 'chip_preview',
            col: 100
          },
          {
            displayName: 'Equipo de especialistas',
            name: 'profesionalEspecialidadRI',
            type: 'chip_preview',
            col: 100
          }]

      }]

  },
  {
    name: 'Equipamiento Adicional',
    programType: ['CP', 'CD'],
    rows: [
      {
        inputs: [
          {
            displayName: 'Requerimientos adicionales',
            name: 'requerimientosAdicionales',
            type: 'chip_preview',
            col: 100
          }]

      }]

  },
  {
    name: 'Buscador de Plan de cuidado a presupuestar',
    rows: [
      {
        inputs: [
          {
            displayName: 'Buscador de Planes',
            name: 'idModulo',
            type: 'search',
            col: 36
          },
          {
            type: 'item',
            col: 64
          }]

      }]

  }];

//#endregion